<script>
import CatalogModelMixin from "../../mixins/CatalogModel";

export default {
    mixins: [CatalogModelMixin],

    props: {
        catalog: {
            type: String,
            required: true,
        },

        locale: {
            type: String,
            required: false,
            default: "it",
        },
    },

    data() {
        return {
            models: [],
            loading: false,
            ready: false,
            filters: {
                locale: this.locale,
            },
            selectedLocale: this.locale,
        };
    },

    created: function () {
        this.$_getBoatModels();
    },

    methods: {
        onCreated(model) {
            this.models.push(model);
            this.$_sortModels();
        },

        onBrandChange(brand) {
            this.filters.brand = brand.id;
            this.$_getBoatModels();
        },

        onLocaleChange(locale) {
            this.filters.locale = locale;

            const url = new URL(window.location.href);
            url.searchParams.set("locale", locale);
            window.history.replaceState({}, "", url.toString());

            this.$_getBoatModels();
        },

        $_getBoatModels() {
            this.loading = true;

            this.getCatalogModels(this.catalog, this.filters)
                .then((response) => {
                    this.models = response.data;
                    this.loading = false;
                    this.ready = true;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },

        $_sortModels() {
            this.models.sort((a, b) => {
                let _a = a.name;
                let _b = b.name;

                if (_a < _b) {
                    return -1;
                } else if (_a == _b) {
                    return 0;
                } else {
                    return 1;
                }
            });
        },
    },
};
</script>
